





































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import ProductPricing from '@/store/entities/product-pricings/product-pricing'
import AppConsts from '@/lib/appconst';
import moment from "vue-moment";
Vue.use(require("vue-moment"));
 @Component
export default class ViewProductPricing extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    productPricing:ProductPricing=new ProductPricing();
    spinShow=false;
    id : number = 0;
    async getInfo()
    {
        await this.$store
            .dispatch({
                type:'productPricing/get',
                 data: {
                    id:this.id,
                }
            })
            .then( res => {
                this.id = res.id;
                this.productPricing = res;
            });
        
    }
    cancel() {
        (this.$refs.productPricingForm as any).resetFields();
        this.$root.$router.push({ name: "productpricing" });
    }
    async save() {
        this.$Modal.confirm({
            title:this.L('Tips'),
            content:this.L('Confirm.UpdateProductPricing'),
            okText:this.L('Yes'),
            cancelText:this.L('No'),
            onOk:async()=>{
                this.spinShow=true;
                try {
                    await this.$store.dispatch({
                        type: "productPricing/update",
                        data: {
                                id:this.productPricing.id,
                                price: this.productPricing.price
                            }
                        }) 
                        .then(result => {
                        Util.showSuccessMsg(this,"Success.UpdateProductPricing");
                        this.cancel();
                    });
                    this.spinShow=false;
                } catch (error) {
                   this.spinShow=false; 
                }
            }
        });
    }
    async created(){
        this.spinShow = true;
        try {
            this.id = +this.$root.$router.currentRoute.params.id;
            await this.getInfo();
            this.spinShow=false;
        } catch (error) {
            this.spinShow=false;
        }
    }
}
